import React, { Children, FC } from 'react'
import style from './ScreenGroup.module.scss'
import classnames from 'classnames'
import { ScreenGroupProps } from './types'
import 'react-aspect-ratio/aspect-ratio.css'
import AspectRatio from 'react-aspect-ratio'
import { OBSERVER } from '../../../dataStore/constants/roles'

const getScreenGroupLayoutClasses = (numberOfScreens = 0, layout: ScreenGroupProps['layout']): string => {

  let fullscreen = false

  if (numberOfScreens <= 1) fullscreen = true

  if (layout === 'list') {

    return classnames(
      style['screengroup'],
      style[`screengroup-list--vertical`],
      style[`screengroup-list--vertical-length-${numberOfScreens}`]
    )

  }

  return classnames(
    style['screengroup'],
    style[`screengroup-screens-${numberOfScreens}`], {
      [style[`screengroup__full-screen`]]: fullscreen,
      [style[`screengroup__two-columns`]]: numberOfScreens >= 2 && numberOfScreens < 5,
      [style[`screengroup__three-columns`]]: numberOfScreens >= 5 && numberOfScreens < 10,
      [style[`screengroup__two-rows`]]: numberOfScreens >= 3 && numberOfScreens < 7,
      [style[`screengroup__three-rows`]]: numberOfScreens >= 7 && numberOfScreens < 10
    }
  )

}

const getValidChildren = (children: React.ReactNode): React.ReactElement[] => {

  const validReactChildren: React.ReactElement[] = []

  Children.forEach(children, (child) => {

    if (!React.isValidElement(child)) return

    validReactChildren.push(child)

  })

  return validReactChildren

}

const ScreenGroup = ({ children, layout = 'gallery', ratio = 'free' }: ScreenGroupProps) => {

  if (!children) return null

  const validReactChildren: React.ReactElement[] = getValidChildren(children)
  const totalChildrenCount = Children.count(validReactChildren)
  //we need to hide observers unless they are screensharing (which means only one child)
  const childrenCount = Children.count(validReactChildren.filter(({props}) => totalChildrenCount > 1 ? props.presenter.role !== OBSERVER : true ))
  const containedChildren = Children.map(validReactChildren, (child, i) => {

    const _child: React.ReactElement = child
    const containerClasses = classnames(
      style[`screengroup-item`],
      style[`screengroup-${i}`])
    const opts = {}

    const newChild = React.cloneElement(_child, opts)

    if (ratio === '16/9') {

      return <AspectRatio ratio='16/9'
        key={`screengroup-container-${i}`}
        className={containerClasses}
      >
        {newChild}
      </AspectRatio>

    }

    return <div
      key={`screengroup-container-${i}`}
      className={containerClasses}
    >
      {newChild}
    </div>

  })

  return <div className={getScreenGroupLayoutClasses(childrenCount, layout)} data-bdd={`talks-screen-group`}>
    {containedChildren}
  </div>

}

export default ScreenGroup
